import { useLocation } from 'react-router-dom';

function useSearchParams(): URLSearchParams {
  const { search } = useLocation();
  return new URLSearchParams(search);
}

export default useSearchParams;
